import React,{useEffect, useRef} from 'react'
import { useState } from 'react'


import { AgGridReact } from 'ag-grid-react';
import 'ag-grid-community/styles/ag-grid.css';
import 'ag-grid-community/styles/ag-theme-alpine.css';
import { useAppData } from '../../../../../../context/AppDataContext';
import ConfirmDialog from '../../../../../../components/ConfirmDialog';
import { Print } from '@mui/icons-material';
import FinanceLayout from '../../../../../../layout/components/FinanceLayout';
import CompanyLocationForm from '../components/CompanyLocationForm';




const CellActions = (props) =>{
    return(
        <>
            <CompanyLocationForm  callBack={props.callBack} data={props.data} />
            <ConfirmDialog id={props.data.id} confirm={ ()=>props.remove(props.data.id)} >Are you Sure You want to remove</ConfirmDialog>
        </>
    )
  }


function CompanyLocationListPage() {

  const {getMasterLabel} = useAppData()
  const {companyLocationList,getCompanyLocationList,getCompanyLocationDD} = useAppData();
  const gridRef = useRef();
  

  const remove = () =>{

  }

  const [defaultColDef] = useState({
    floatingFilter: true,
    filterParams: {
      buttons: ['apply'],
    },
    resizable: true,
    width:120,
    filter:true,
    sortable: true,
    cellStyle: { 'textTransform': 'uppercase' },
  });


  const [columnDefs,setColumnDef] = useState();
    const prepairColumnDef = () => {
    let _columnDefs = [
        {field:"id",headerName: "ID"},
        {field:"title",headerName: "Project Location",width:250},
        {field:"orgName",headerName: "Org",width:250},
        {field:"city",headerName: "City"},
        {field:"state",headerName: "State"},
        
        
        
        {headerName:"Action", width:"200", valueGetter: params => params.data.title,
            cellRenderer: CellActions,
            cellRendererParams: {
                callBack:getCompanyLocationList,
                remove:remove
            },
        },      
    ];
    setColumnDef(_columnDefs);
  }

  const onBtnExport = () => {
    gridRef.current.api.exportDataAsCsv("data.csv");
  };

  useEffect(()=>{    
    prepairColumnDef();
  },[]);

  const companyLocationCallBack = () =>{
    getCompanyLocationList();
    getCompanyLocationDD();
  }
  return (
    <FinanceLayout>
      <div className='row'>
        <div className='col-md-6'><h4>Company Locations</h4></div>
        <div className='col-md-6'> 
          <span className='float-end'><CompanyLocationForm callBack={companyLocationCallBack} /></span>
          <button className='btn btn-warning me-2 float-end' onClick={onBtnExport} ><Print /> Export </button>
        </div>
        <div className='col-md-12 mt-2'>
          <div className="ag-theme-alpine" style={{height: 400}}>
              <AgGridReact
                ref={gridRef}
                rowData={companyLocationList}
                columnDefs={columnDefs}
                defaultColDef={defaultColDef}
                animateRows={true}
                onGridReady={getCompanyLocationList}
              />
            </div>
          </div>
        </div>
    </FinanceLayout>
    
  )
}

export default CompanyLocationListPage